import React from 'react';
import { Me } from '../types';

export const MeContext = React.createContext<Me | null>(null);
